import { render, staticRenderFns } from "./DeliverySplitRuleDialog.vue?vue&type=template&id=3a469d91&scoped=true&"
import script from "./DeliverySplitRuleDialog.vue?vue&type=script&lang=ts&"
export * from "./DeliverySplitRuleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeliverySplitRuleDialog.vue?vue&type=style&index=0&id=3a469d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a469d91",
  null
  
)

export default component.exports